import { $httpChangiRecommends } from '@/core/api';
const state = {
    items: [],
    productPromoCodes: [],
    loaded: false,
    loading: false,
    ableToCheckout: false,
    subtotal: 0,
    cartMessages: [],
    fxOrderData: null,
    doricESimOrderData: null,
    changiAssureOrderData: null,
};
const mutations = {
    clearCart(state) {
        state.items = [];
        state.productPromoCodes = [];
        state.ableToCheckout = false;
        state.subtotal = 0;
    },
    setProductPromoCodes(state, productPromoCodes) {
        state.productPromoCodes = productPromoCodes;
    },
    addOrUpdateProductPromoCodes(state, payload) {
        const { productUnitUuid, promoCode, discountAmount } = payload;
        const existingIndex = state.productPromoCodes.findIndex(p => p.productUnitUuid === productUnitUuid);
        if (existingIndex !== -1) {
            state.productPromoCodes.splice(existingIndex, 1, { productUnitUuid, promoCode, discountAmount });
        }
        else {
            state.productPromoCodes.push({ productUnitUuid, promoCode, discountAmount });
        }
    },
    removeProductPromoCode(state, { productUnitUuid, promoCode }) {
        const index = state.productPromoCodes.findIndex(p => p.productUnitUuid === productUnitUuid && p.promoCode === promoCode);
        if (index !== -1)
            state.productPromoCodes.splice(index, 1);
        state.productPromoCodes.splice(0, state.productPromoCodes.length, ...state.productPromoCodes.filter(p => p.promoCode !== promoCode));
    },
    removeProductPromoCodeByProductUnitUuid(state, productUnitUuid) {
        const index = state.productPromoCodes.findIndex(p => p.productUnitUuid === productUnitUuid);
        if (index !== -1)
            state.productPromoCodes.splice(index, 1);
    },
    updatePromoCodeDiscount(state, { productUnitUuid, discountAmount }) {
        const target = state.productPromoCodes.find(p => p.productUnitUuid === productUnitUuid);
        if (target) {
            target.discountAmount = discountAmount;
        }
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setLoaded(state, loaded) {
        state.loaded = loaded;
    },
    setItems(state, cartItems) {
        state.items = cartItems;
    },
    addItem(state, cartItem) {
        if (state.items.some((item) => item.selectedUnitUuid === cartItem.selectedUnitUuid)) {
            state.items = state.items.map((i) => i.selectedUnitUuid === cartItem.selectedUnitUuid
                ? { ...cartItem, quantity: cartItem.quantity + i.quantity }
                : i);
        }
        else {
            state.items = [...state.items, cartItem];
        }
    },
    removeItem(state, uuid) {
        state.items = state.items.filter((item) => uuid !== item.selectedUnitUuid);
    },
    setItemQuantity(state, cartItem) {
        state.items = state.items.map((item) => item.selectedUnitUuid === cartItem.selectedUnitUuid ? cartItem : item);
    },
    updateItemPromo(state, cartItem) {
        state.items = state.items.map((item) => item.selectedUnitUuid === cartItem.selectedUnitUuid ? cartItem : item);
    },
    updateCartFromResponse(state, payload) {
        if (!payload.ableToCheckout) {
            state.cartMessages = payload.cartMessages;
            state.ableToCheckout = payload.ableToCheckout;
            state.cartMessages = payload.cartMessages;
            if (payload.items && payload.items.length > 0) {
                state.items = payload.items.map((item) => {
                    let selectedUnit = item.selectedVariant?.units?.find((unit) => unit.uuid === item.selectedUnitUuid);
                    return {
                        ...item,
                        selectedUnit: selectedUnit,
                    };
                });
            }
            else {
                state.items = [];
            }
        }
        else {
            state.subtotal = payload.subtotal ? payload.subtotal : 0;
            state.ableToCheckout = payload.ableToCheckout;
            state.cartMessages = payload.cartMessages;
            state.items = payload.items.map((item) => {
                let selectedUnit = item.selectedVariant?.units?.find((unit) => unit.uuid === item.selectedUnitUuid);
                return {
                    ...item,
                    selectedUnit: selectedUnit,
                };
            });
        }
    },
};
const actions = {
    async checkCallback({ commit, }) {
        commit('setLoading', true);
        await $httpChangiRecommends.api
            .checkApiHubCallback({ sessionId: this._sessionId })
            .then((response) => {
            if (response.data.fxOrderData) {
                commit('setFxOrderData', response.data.fxOrderData);
            }
            if (response.data.doricESimOrderData) {
                commit('setDoricESimOrderData', response.data.doricESimOrderData);
            }
            if (response.data.changiAssureOrderData) {
                commit('setChangiAssureOrderData', response.data.changiAssureOrderData);
            }
            commit('setLoaded', true);
        })
            .catch((err) => {
            commit('setLoaded', false);
            console.error(err);
        })
            .finally(() => commit('setLoading', false));
    },
    async getCartItems({ commit, dispatch, getters }) {
        commit('setLoading', true);
        await $httpChangiRecommends.api
            .ChangiRecommendsGetCartItems()
            .then((response) => {
            let cartResponse = response.data;
            if (typeof cartResponse.items === 'undefined') {
                cartResponse.items = [];
            }
            commit('updateCartFromResponse', cartResponse);
            commit('setLoaded', true);
        }).then(() => {
            if (getters.cartItemsNumber > 0) {
                dispatch('checkoutModule/getAvailablePromoCodes', null, { root: true });
                dispatch('checkoutModule/callApplyOrderPromoCode', { code: null, showLoading: false }, { root: true });
            }
        })
            .catch((err) => {
            commit('setLoaded', false);
            console.error(err);
        })
            .finally(() => commit('setLoading', false));
    },
    async addItem({ commit, dispatch }, payload) {
        return await $httpChangiRecommends.api.ChangiRecommendsAddToCart(payload).then((response) => {
            let cartResponse = response.data;
            commit('updateCartFromResponse', cartResponse);
            //dispatch('triggerPromoCodeVerify');
        }).then(() => {
            dispatch('checkoutModule/getAvailablePromoCodes', null, { root: true });
            dispatch('checkoutModule/callApplyOrderPromoCode', { code: null, showLoading: false }, { root: true });
        });
    },
    updateItemQuantity({ commit, dispatch }, payload) {
        let apiPayload = {
            cartUuid: payload.cartUuid,
            quantity: payload.quantity,
        };
        return $httpChangiRecommends.api
            .ChangiRecommendsUpdateCartQuantity(apiPayload)
            .then((response) => {
            let cartResponse = response.data;
            commit('updateCartFromResponse', cartResponse);
            dispatch('triggerPromoCodeVerify');
        });
    },
    removeItem({ commit, dispatch, getters, rootState, }, payload) {
        commit('checkoutModule/setApplyPromoCodeLoading', true, { root: true });
        let apiPayload = {
            cartUuid: payload.cartUuid,
        };
        return $httpChangiRecommends.api.ChangiRecommendsRemoveCartItem(apiPayload).then((response) => {
            if (getters.cartItemsNumber >= 0) {
                commit('checkoutModule/setAppliedPromoCode', null, { root: true });
                commit('checkoutModule/setDiscountRewardPoints', 0, { root: true });
            }
            let cartResponse = response.data;
            if (typeof cartResponse.items === 'undefined') {
                cartResponse.items = [];
            }
            commit('removeProductPromoCodeByProductUnitUuid', payload.selectedUnitUuid);
            commit('updateCartFromResponse', cartResponse);
        }).then(() => {
            console.log('getters.cartItemsNumber :' + getters.cartItemsNumber);
            if (getters.cartItemsNumber > 0) {
                dispatch('checkoutModule/getAvailablePromoCodes', null, { root: true });
                dispatch('checkoutModule/callApplyOrderPromoCode', { code: null, showLoading: false }, { root: true });
            }
        }).finally(() => commit('checkoutModule/setApplyPromoCodeLoading', false, { root: true }));
        // dispatch('triggerPromoCodeVerify');
    },
    async updateCartItemVariant({ commit, dispatch }, payload) {
        await $httpChangiRecommends.api.ChangiRecommendsUpdateCartUnit(payload).then((response) => {
            let cartResponse = response.data;
            commit('updateCartFromResponse', cartResponse);
            dispatch('triggerPromoCodeVerify');
        });
    },
    clearCart({ commit }) {
        $httpChangiRecommends.api.ChangiRecommendsRemoveAllCartItemsUponCheckout().then((response) => {
            commit('clearCart');
        });
    },
    triggerPromoCodeVerify({ getters, dispatch, rootState, }) {
        if (getters.cartItemsNumber > 0 &&
            rootState['checkoutModule'].appliedPromoCode) {
            dispatch('checkoutModule/applyPromoCode', rootState['checkoutModule'].appliedPromoCode?.code, { root: true });
        }
    },
};
const getters = {
    cartItemsNumber: (state) => {
        return state.items.reduce((acc, curr) => {
            acc += curr.quantity;
            return acc;
        }, 0);
    },
    cartItemsPrice: (state) => {
        const activeProducts = state.items.filter((item) => {
            return item.status == true;
        });
        const total = activeProducts.reduce((acc, curr) => acc + curr.totalPrice, 0);
        return Number(total.toFixed(2));
    },
    cartTaxTotal: (state) => {
        const activeProducts = state.items.filter((item) => {
            return item.status == true;
        });
        const total = activeProducts.reduce((acc, curr) => acc + curr.totalPrice, 0);
        // $price / (1 + ($taxRateValue / 100)) * ($taxRateValue / 100);
        const tax = activeProducts.reduce((acc, curr) => acc +
            (curr.product.isTaxable
                ? (curr.totalPrice /
                    (1 + parseFloat(curr.product.taxRate.value) / 100)) *
                    (parseFloat(curr.product.taxRate.value) / 100)
                : 0), 0);
        return Number(tax.toFixed(2));
    },
    /**
     * @todo In final, tax rate should be passed from backend
     */
    cartItemsPriceWithoutTax: (state, getters) => {
        let cartItemsPrice = getters.cartItemsPrice;
        let cartTaxTotal = getters.cartTaxTotal;
        return cartItemsPrice - cartTaxTotal;
    },
    /**
     * @todo In final, tax rate should be passed from backend
     */
    cartItemsTaxAmount: (state, getters) => {
        return getters.cartTaxTotal;
    },
    hasAnyPreorderItem: (state) => {
        return (state.items.filter((item) => {
            return item.product.is_preorder;
        }).length > 0);
    },
};
export const cartModule = {
    state,
    mutations,
    actions,
    namespaced: true,
    getters,
};
